'use client'
import React from 'react'
import getStatus from '@/shared/hooks/useStatus'
import MyImage from '../../myImage'
import { convertDate, getImgURL, getTimeZone } from '@/shared/utils'
import CustomLink from '../../customLink'
import TeamPlaceholder from '@/assets/images/placeholder/team.png'
import { useQuery } from '@apollo/client'
import { UPCOMING_FANTASY_TIPS } from '@/graphql/fantsy-tips/fantasyTips.query'

function UpcomingFantasyTips() {
  const { data } = useQuery(UPCOMING_FANTASY_TIPS, {
    variables: { input: { nLimit: 40, nOrder: 1, sTimezone: getTimeZone(), nSkip: 1 } }
  })

  const fantasyTips = data?.listUpcomingFantasyTipsFront?.aResults

  if (fantasyTips?.length === 0) return null

  const statusColor: Record<string, string> = {
    live: 'text-danger',
    scheduled: 'text-ScheduledBG',
    completed: 'text-primary-500',
    cancelled: 'text-danger'
  }

  return (
    <>
      <section className="w-full">
        <div className="flex justify-between items-center mb-4 mt-3">
          <h3 className="font-bold text-lg mb-0 text-textOffWhite flex items-center justify-center md:justify-start">
            <span>Fantasy Tips</span>
          </h3>
        </div>
        {fantasyTips?.map((match: any, i: number) => {
          const { sStatus, sStatusStr, sLiveGameStatus } = getStatus(match as any)
          return (
            <CustomLink
              prefetch={false}
              key={i}
              className={`p-0 md:block hidden`}
              href={`/fantasy-cricket-tips/${match?.aFantasyTips[0]?.oSeo?.sSlug}`}
            >
              <div
                key={i}
                className="flex flex-col border border-tabBorder rounded-xl pt-2.5 pb-4 px-3 mt-4 bg-cardBg"
              >
                <p className="flex items-center mb-3 text-ellipsis whitespace-nowrap">
                  <span
                    className={`font-medium text-xs flex items-center ${statusColor[sStatusStr]}`}
                  >
                    {sStatusStr === 'live' ? (
                      <>
                        <span className="h-2.5 w-2.5 rounded-full bg-danger mr-1" />
                        {sLiveGameStatus}
                      </>
                    ) : (
                      sStatus
                    )}
                  </span>
                  {match?.sFormatStr ? (
                    <>
                      <span className="h-1.5 w-1.5 rounded-full dark:bg-[#6B7280] bg-[#AAAAAA] mx-1.5"></span>
                      <span className="text-xs font-normal text-textDselected">
                        {match?.sFormatStr}{' '}
                      </span>
                    </>
                  ) : null}
                  {match?.oSeries?.sTitle && (
                    <>
                      <span className="h-1.5 w-1.5 rounded-full dark:bg-[#6B7280] bg-[#AAAAAA]  mx-1.5"></span>
                      <span className="text-xs font-normal text-textDselected line-clamp-1 overflow-hidden  truncate ">
                        {match?.oSeries?.sTitle}
                      </span>
                    </>
                  )}
                </p>
                <div className="flex justify-between items-center">
                  <div className="flex gap-2 items-center">
                    <div className="align-middle min-w-[25px] object-cover overflow-hidden">
                      <MyImage
                        src={getImgURL(match?.oTeamA?.oImg?.sUrl)}
                        className="rounded-full aspect-square"
                        height={36}
                        width={36}
                        placeholderImage={TeamPlaceholder}
                      />
                    </div>
                    <div className=" text-sm font-bold text-textOffWhite">
                      {match?.oTeamA?.sAbbr}
                    </div>
                  </div>
                  <div className="text-textDselected">Vs</div>
                  <div className="flex gap-2 items-center ">
                    <div className=" text-sm font-bold text-textOffWhite">
                      {match?.oTeamB?.sAbbr}
                    </div>
                    <div className="align-middle min-w-[25px] object-cover overflow-hidden">
                      <MyImage
                        src={getImgURL(match?.oTeamB?.oImg?.sUrl)}
                        className="rounded-full aspect-square"
                        height={36}
                        width={36}
                        placeholderImage={TeamPlaceholder}
                      />
                    </div>
                  </div>
                </div>
                <h6 className="pt-2 text-xs text-center font-medium text-TextScoredCompplete">
                  {convertDate(match?.dStartDate)}
                </h6>
              </div>
            </CustomLink>
          )
        })}
      </section>
    </>
  )
}

export default UpcomingFantasyTips
